import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  root: {
    fontWeight: 400,
    fotnSize: theme.fontSizes.sm,
    borderRadius: theme.spacing.md / 2,
    '& span': {
      color: theme.colors.dark[9],
    },
  },
  headerEdit: {
    position: 'absolute',
    right: 8,
    top: 8,
  },
  headerEditEntrants: {
    position: 'absolute',
    right: 108,
    top: 8,
  },
}));

export default useStyles;
